var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.7422 137.816C77.1329 156.087 78.227 187.339 78.3833 190.785C78.9382 198.155 81.7593 205.602 86.1512 210.854C92.2624 218.223 99.7881 221.513 110.283 221.513C124.788 221.591 140.777 221.591 156.305 221.591C171.896 221.591 187.025 221.591 199.802 221.513C210.149 221.513 217.909 218.137 223.942 210.854C228.334 205.602 231.155 198.076 231.554 190.785C231.71 187.886 232.492 153.962 232.96 137.816H76.7422Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.992 171.463V181.575C148.992 184.81 151.618 187.436 154.853 187.436C158.089 187.436 160.714 184.81 160.714 181.575V171.463C160.714 168.227 158.089 165.602 154.853 165.602C151.618 165.602 148.992 168.227 148.992 171.463Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.91 164.994C140.128 167.831 137.401 169.644 134.447 169.253C114.511 166.471 95.4587 159.398 79.3758 148.778C77.7269 147.7 76.7422 145.855 76.7422 143.886V116.8C76.7422 100.389 90.1211 87.0411 106.571 87.0411H121.943C123.412 75.694 133.024 66.8711 144.762 66.8711H164.94C176.67 66.8711 186.29 75.694 187.759 87.0411H203.209C219.613 87.0411 232.96 100.389 232.96 116.8V143.886C232.96 145.855 231.968 147.692 230.334 148.778C214.22 159.445 195.09 166.549 175.021 169.323C174.748 169.362 174.482 169.378 174.216 169.378C171.567 169.378 169.199 167.588 168.535 164.963C166.956 158.742 161.306 154.389 154.812 154.389C148.232 154.389 142.644 158.648 140.91 164.994ZM164.94 78.5933H144.762C139.503 78.5933 135.111 82.1881 133.798 87.0411H175.896C174.584 82.1881 170.192 78.5933 164.94 78.5933Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessEmpty);
export default __webpack_public_path__ + "static/media/BusinessEmpty.e9466a6c4c2751c01036a83577eceebc.svg";
export { ForwardRef as ReactComponent };